export const ROUTES = {

    // Public Routes
    HOME: '/',
    ABOUT: '/about',
    CONTACT_US: '/contact',
    PROJECTS: '/projects',
    GALLERY: '/gallery',
    LOCATIONS: '/locations',
    AMENITIES: '/amenities',
    PROJECT: (slug: string) => `/projects/${slug}`,

    // Auth
    LOGIN: '/login',
    SIGN_UP: '/sign-up',

    // Private Routes
    DASHBOARD: '/dashboard',
    DASHBOARD_DEFAULT: '/dashboard/default',
    DASHBOARD_ADMIN: '/dashboard/admin',
    DASHBOARD_MANAGER: '/dashboard/manager',
    DASHBOARD_TEAM_LEADER: '/dashboard/team-leader',
    DASHBOARD_AGENT: '/dashboard/agent',
    DASHBOARD_SITE_VISIT_EXECUTIVE: '/dashboard/site-visit-executive',
    DASHBOARD_EXECUTIVE: '/dashboard/md',
    DASHBOARD_GM: '/dashboard/gm',
    DASHBOARD_DIRECTOR: '/dashboard/director',
    DASHBOARD_MD: '/dashboard/md',
    DASHBOARD_ASSISTANT_MANAGER: '/dashboard/assistant-manager',
    AGENT_DASHBOARD: '/dashboard/agent',
    PROFILE: '/profile',
    ADMIN_DASHBOARD: '/admin-dashboard',
    AI_AGENT: '/ai-agent',
    INBOUND_CENTER: '/inbound-center',
    OUTBOUND_CAMPAIGNS: '/outbound-campaigns',
    PREDICTIVE_DAILERS: '/predictive-dailers',
    AGENT_OVERVIEW: '/agent-overview',
    LIVE_CALLS: '/live-calls',
    CALLBACKS: '/callbacks',
    MISSED_CALLS: '/missed-calls',
    CRM: '/crm',
    LEAD_MANAGEMENT: '/lead-management',
    APPOINTMENTS: '/appointments',
    TRANSPORT_MANAGEMENT: '/transport-management',
    SITE_VISITS: '/site-visits',
    SALES_PERSON_ASSIGNMENT: '/sales-person-assignment',
    PROPERTY_MANAGEMENT: '/property-management',
    WHATSAPP: '/whatsapp',
    WHATSAPP_ASSIGNMENT: '/whatsapp-assignment',
    WHATSAPP_TEMPLATES: '/whatsapp-templates',
    SMS: '/sms',
    EMAIL: '/email',
    CONVERSATION_INTEL: '/conversation-intel',
    KNOWLEDGE_BASE: '/knowledge-base',
    SCRIPTS: '/scripts',
    AGENT_ANALYTICS: '/agent-analytics',
    USER_MANAGEMENT: '/user-management',
    WORKING_HOURS: '/working-hours',
    ROLES_PERMISSIONS: '/roles-permissions',
    INTEGRATIONS: '/integrations',
    DID_MANAGEMENT: '/did-management',
    BLOCKED_NUMBERS: '/blocked-numbers',
    SECURITY: '/security',
    SETTINGS: '/settings',
    AGENT_REPORTS: '/agent-reports',
    CALL_EVALUATION_REPORTING: '/call-evaluation-reporting',
    MARKETING_ANALYTICS: '/marketing-analytics',
    TEAM_CHAT: '/team-chat',
    AUDIT_LOGS: '/audit-logs',
}

export const mainNav = [
    { label: "Home", href: ROUTES.HOME },
    { label: "Projects", href: ROUTES.PROJECTS },
    { label: "About", href: ROUTES.ABOUT },
    { label: "Gallery", href: ROUTES.GALLERY },
    { label: "Contact", href: ROUTES.CONTACT_US }
];